module.exports = __webpack_public_path__ + "img/configura-mail-alertduedate.59f4e40b.png";